import {
    network,
    PortForwardingAPIConnectorError,
    PortForwardingAPIConnectorExceedingLimitError
} from "../lib/Network.ts";
import {swal_util} from "../lib/SwalUtil.ts";
import type {Port} from "../lib/ModelTypes.ts";
import {t} from "i18next";


export async function addPort(instanceId: number, proto: string, internPort: number): Promise<Port | undefined> {
    try {
        swal_util.show_loading(t("portForwarding.loading.addPort")).finally();
        const port = await network.portForwardRule.add(instanceId, proto, internPort);
        await swal_util.hide_loading();

        return port;
    } catch (err) {
        if (err instanceof PortForwardingAPIConnectorExceedingLimitError) {
            const text = err.localization.replace("{limitAmountData}", err.bundle.amount.toString());
            const data = text.replace("{limitQuotaData}", err.bundle.quota.toString());
            await swal_util.show_error(data);
        } else if (err instanceof PortForwardingAPIConnectorError) {
            if (err.localization === undefined) {
                await swal_util.show_error(t("portForwarding.addPortFailed"));
            }
            await swal_util.show_error(`${err.localization}`);
        } else {
            await swal_util.show_error(`${err}`);
        }
        console.error(err);
        throw err;
    } finally {
        await swal_util.hide_loading();
    }
}